export const ORDERED_DELIVERY_MODES = [
    "eezeeSend",    // Eezee Driver A
    "eezeeSend_2",  // Eezee Driver B
    "external_1", // External A
    "external_2", // External B
    "external_3", // External C
    "external_4", // External D
    "external_5", // External E
    "supplierSend",   // Supplier Send Cust 
    "supplierSend_2", // Supplier Send Eezee
    "international", // International
    "adhoc",
    "eezeeTeam",
    "janio",
    "lalamove",
    "tckExpress"
]

export const DELIVERY_MODES_PRETTY = {
    "eezeeSend": 'Eezee Driver A',  
    "eezeeSend_2": 'Eezee Driver B', 
    "external_1": 'External A',
    "external_2": 'External B',
    "external_3": 'External C',
    "external_4": 'External D',
    "external_5": 'External E',
    "supplierSend": 'Supplier Send - Cust',
    "supplierSend_2": 'Supplier Send - Eezee',
    "international": 'International',
    "adhoc": 'Ad-Hoc',
    "eezeeTeam": 'Eezee Team',
    
    // Legacy
    "janio": 'Janio',
    "lalamove": "Lalamove",
    "tckExpress": 'External A',
}


// WEBPACK FOOTER //
// ./src/components/delivery-page/config.js